import React from '../node_modules/react';
import BookingComponent from '@protacon/muster-booking-frontend';
import '@protacon/muster-booking-frontend/dist/styles.bundle.css';

function App() {
    const urlParams = new URLSearchParams(window.location.search);

    // const bookingEdit = localStorage.getItem('booking_edit') ? localStorage.getItem('booking_edit') : false;
    const bookingEdit = urlParams.has('edit');

    return (
        bookingEdit ? (
                <BookingComponent
                    locale="sv"
                    timezone="Europe/Stockholm"
                    apiEndpoint="https://booking-api.muster.se/v1"
                    maxStations={5}
                    chainId={2}
                    googleApiKey="AIzaSyD32Uu1F6yXHVPZTjFtD3g8kqd-wNlPfLU"
                    plateNumber={localStorage.getItem('regNo') ? localStorage.getItem('regNo').toUpperCase() : ''}
                    modifyExisting={{}}
                    searchReservation={{
                        bookingNumber: '',
                        lastName: ''
                    }}
                />
            ) : (
                <BookingComponent
                    locale="sv"
                    timezone="Europe/Stockholm"
                    apiEndpoint="https://booking-api.muster.se/v1"
                    chainId={2}
                    googleApiKey="AIzaSyD32Uu1F6yXHVPZTjFtD3g8kqd-wNlPfLU"
                    plateNumber={localStorage.getItem('regNo') ? localStorage.getItem('regNo').toUpperCase() : ''}
                    maxStations={5}
                    product="Inspection"
                />
            )
    )
}

export default App;


// WEBPACK FOOTER //
// ./booking/app.js